import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {

    if (this.props.show !== true)
      return <div></div>;

    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container style={{ direction: "ltr" }}>

            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/ghorekeshi">قرعه کشی</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/prizePage">جوایز</NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/sendSMSTable"> پیامکهای ارسالی</NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/recieveSMSTable">ریزگزارش شرکت کنندگان</NavLink>
                </NavItem>


                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/aggregateMobileTable"> تجمیعی شرکت کنندگان</NavLink>
                </NavItem>

                
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/productTable">گزارش محصولات</NavLink>
                </NavItem>

                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/pointTable">امتیاز ها</NavLink>
                </NavItem>


                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/memberTable"> اعضا</NavLink>
                </NavItem>





                <NavItem >
                  <NavLink tag={Link} className="text-dark" to="/logout">x</NavLink>
                </NavItem>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js